



















































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import HelpContent from '@/components/HelpContent.vue'
import { i18n } from "@/i18n/i18n-setup";

@Component({
    components: {
        HelpContent
    }
})
export default class WelcomeKitDeliveryInfoPage extends Vue {
    file: any = [];
    uploading: boolean = false;
    uploadComplete: boolean = false;
    modal_welcomeKitDeliveryInfo : string = "modal-welcomeKitDeliveryInfo"

    mounted() {
    }
    @Watch('file')
    fileChange(fileVal: any) {
        this.file = fileVal;
        this.uploadFile();
    }

    async uploadFile() {
        this.uploading = true;
        this.uploadComplete = false;
        let app = this;
        let formData = new FormData();
        formData.append('file', this.file);
        
        try {
            let response = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/net20/ImportWelcomeKitDeliveryInfo'),
                data: formData,
                withCredentials: true
            });

            app.onUploadComplete();
            
            if (response.data.errors) {
                let error = "";
                for (let i = 0; i < response.data.errors.length; i++) {
                    error += response.data.errors[i] + "<br/>";
                }
                General.showAlertDangerAsHTML(error, app);
            }
            else {
                General.showAlertSuccess(i18n.t("NET20.WK_INFO_UPLOAD_SUCCESS") as string, app);
            }
            
        }catch(error){
            General.HandleError(error, this);
        }
     
    }
    onUploadComplete() {
        this.uploading = false;
        this.uploadComplete = true;
    }
    reset() {
        this.uploading = false;
        this.uploadComplete = false;
    }
    getDownloadWelcomeKitDeliveryInfoUrl() {
        let url = General.GetApiUrl('/api/net20/DownloadWelcomeKitDeliveryInfo');
        return url;
    }

    getWelcomeKitDeliveryInfoUrl() {
        let url = General.GetApiUrl('/api/net20/DownloadWelcomeKitDeliveryInfo');
        return url;
    }
}
